<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <div  class="div-query-banner"  >
          <a-button  class="query-banner-btn" type="primary" @click="searchQuery" icon="search">刷新</a-button>
          <!-- <a-button  class="query-banner-btn" type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button> -->
        </div>
      </a-form>
    </div>
    <!-- 查询区域-END -->
    
    <!-- 操作按钮区域 -->
    <a-form layout="vertical"  :colon="true"  >
    <div class="div-operator-flex">
      <a-form-item label="部门: "  >
          <j-dict-select-tag ref="departSelectTag" v-model="selectDepartId"   placeholder="请选择部门"   ></j-dict-select-tag>
      </a-form-item>
      <a-form-item label="区域: " >
        <j-dict-select-tag  ref="workshopSelectTag" v-model="selectWorkshopId" placeholder="请输入区域id"  :dictCode="workshopSelectDictCode"  ></j-dict-select-tag>
      </a-form-item>
      <a-button class="query-banner-btn" @click="handleAddWorkshop" type="primary" icon="plus">添加</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>
    </div>
    </a-form>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{fixed:true,selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        @change="handleTableChange">

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="图片不存在" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无此文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="uploadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <workshop-group-detail-modal ref="modalForm" @ok="modalFormOk"></workshop-group-detail-modal>
  </a-card>
</template>

<script>

  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import WorkshopGroupDetailModal from '../modules/WorkshopGroupDetailModal'
  import { queryDepartByBaseNo } from '@/api/api'
  import { postAction } from '@/api/manage'
  import { filterObj } from '@/utils/util';
  
  export default {
    name: "BusInspectionGroupWorkshopList",
    mixins:[JeecgListMixin],
    components: {
      WorkshopGroupDetailModal
    },
    data () {
      return {
        description: '巡检分组区域配置表管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'区域',
            align:"center",
            dataIndex: 'workshop'
          },
          {
            title: '操作',
            dataIndex: 'action',
            align:"center",
            scopedSlots: { customRender: 'action' }
          }
        ],
        url: {
          list: "/general/groupworkshop/busInspectionGroupWorkshop/list",
          delete: "/general/groupworkshop/busInspectionGroupWorkshop/delete",
          deleteBatch: "/general/groupworkshop/busInspectionGroupWorkshop/deleteBatch",
          exportXlsUrl: "/general/groupworkshop/busInspectionGroupWorkshop/exportXls",
          importExcelUrl: "general/groupworkshop/busInspectionGroupWorkshop/importExcel",
        },
        dictOptions:{},
        choosedGroupRecord:{},
        selectDepartId:"",
        selectWorkshopId:"",
      }
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      workshopSelectDictCode(){
        if(!this.selectDepartId){
          return ""
        }else{
          return `bus_inspection_general_depart_workshop,workshop,id,depart_id='${this.selectDepartId}' AND status = '1'`
        }
      }
    },
    methods: {
      initDictConfig(){
      },
      choosedGroup(record){
        this.choosedGroupRecord=record
        queryDepartByBaseNo({baseNo:record.baseNo}).then((res)=>{
          if(res.code==200&&res.success){
            let dictOptions=res.result.map((item)=>{
              return {
                value:item.id,
                label:item.depart,
              }
            })
            this.$refs.departSelectTag.setCurrentDictOptions(dictOptions)
          }
        }).catch((error)=>{
          this.$message.error(error)
        })
        this.loadData(1);
      },
      handleEdit: function (record) {
        this.$refs.modalForm.edit(record);
        this.$refs.modalForm.title = "编辑";
        this.$refs.modalForm.disableSubmit = false;
      },
      handleAdd: function () {
        let record={
          groupId:this.choosedGroupRecord.groupId,
          groupName:this.choosedGroupRecord.groupName
        }
        this.$refs.modalForm.add(record);
        this.$refs.modalForm.title = "新增";
        this.$refs.modalForm.disableSubmit = false;
      },
      getQueryParams () {
          //获取查询条件
          let sqp = {}
          if (this.superQueryParams) {
              sqp['superQueryParams'] = encodeURI(this.superQueryParams)
          }
          var param = Object.assign(sqp, this.queryParam, this.isorter, this.filters);
          param.field = this.getQueryField();
          param.pageNo = this.ipagination.current;
          param.pageSize = this.ipagination.pageSize;
          param.groupId=this.choosedGroupRecord.groupId
          return filterObj(param);
      },
      handleAddWorkshop(){
        let workshopName=this.$refs.workshopSelectTag.getSelectLabels();
        if(!this.selectWorkshopId){
          this.$message.error("请选择区域")
        }
        let paramsData={
          groupId:this.choosedGroupRecord.groupId,
          workshopId:this.selectWorkshopId,
          workshopName
        }
        postAction("/general/groupworkshop/busInspectionGroupWorkshop/add",paramsData).then((res)=>{
          if(res.success){
            that.$message.success(res.message);
          }else{
            that.$message.warning(res.message);
          }
        }).finally(() => {
          this.loadData();
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  @import '~@assets/less/common.less';
   .div-query-banner{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    &>*:nth-child(n){
      width:200px;
      
    }
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
  .div-operator-flex{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    &>.ant-form-item{
      display: flex;
      width:200px;
      justify-content: flex-start;
      align-items: center;
      /deep/.ant-form-item-control-wrapper{
        flex-grow: 1;
        margin-left: 10px;
      }
      /deep/.ant-form-item-label{
        padding:0 !important;
      }
    }
    
    &>*:nth-child(n+2){
      margin-left: 12px;
    }
    &>.query-banner-btn:nth-child(n){
      width:100px
    }
  }
  /deep/.row-choose-bgblue{
    background: #e6f7ff !important;
  }
</style>